'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
require('../../../components/Card/Card.js');
require('../../../components/Card/CardBody.js');
require('../../../components/Card/CardFooter.js');
require('../../../components/Card/CardHeader.js');
require('../../../components/Card/CardHeaderAddon.js');
require('../../../components/Card/CardEditButton.js');
require('../../../components/Card/CardHeaderEditButton.js');
require('../../../components/Card/CardFooterEditButton.js');
var CardEmpty = require('../../../components/Card/CardEmpty.js');
var useEditCard = require('./useEditCard.js');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * Edit card empty component
 *
 * Will be rendered if the card is empty.
 */
var EditCardEmpty = react.forwardRef(function (props, ref) {
  var _useEditCardContext = useEditCard.useEditCardContext(),
    isEmpty = _useEditCardContext.isEmpty,
    isEditing = _useEditCardContext.isEditing;
  if (!isEmpty || isEditing) return null;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(CardEmpty.CardEmpty, _extends__default["default"]({
    ref: ref
  }, props)));
});
EditCardEmpty.displayName = 'EditCardEmpty';
exports.EditCardEmpty = EditCardEmpty;